{
  "categoryCard": {
    "dropdown": {
      "translationButton": "Übersetzungen ansehen",
      "editButton": "Bearbeiten",
      "deleteButton": "Löschen"
    },
    "questionsCount": "{{questionCount}} Fragen",
    "noQuestions": "Noch keine Fragen",
    "exploreQuestionsButton": "Andere Fragen erkunden",
    "addQuestionsButton": "Fragen hinzufügen",
    "lastAskedText": "Zuletzt gefragt",
    "notAskedText": "Noch nicht gefragt",
    "satisfactionScoreText": "Zufriedenheitsbewertung"
  },
  "teamPerformanceCard": {
    "comparedToAverage": {
      "more": "mehr als der Unternehmensdurchschnitt",
      "less": "weniger als der Unternehmensdurchschnitt",
      "same": "gleich dem Unternehmensdurchschnitt"
    },
    "companyBaseline": "Unternehmensbaseline {{score}}",
    "notEnoughResponses": "Nicht genügend Antworten"
  },
  "insightsCard": {
    "responseCount": "{{responseCount}} Antworten"
  },
  "integrationCard": {
    "status": {
      "connected": {
        "verified": "Verifiziert",
        "configured": "Konfiguriert",
        "connected": "Verbunden",
        "managed": "Verwaltet"
      },
      "notConnected": {
        "verify": "Verifizieren",
        "configure": "Konfigurieren",
        "connect": "Verbinden",
        "manage": "Verwalten"
      }
    },
    "connected": "Verbunden",
    "not_connected": "Nicht verbunden"
  },
  "questionHistoryRow": {
    "responseCount_one": "{{formattedResponses}} Antwort",
    "responseCount_other": "{{formattedResponses}} Antworten",
    "insufficientResponses": "Unzureichende Antworten",
    "questionButton": "Details ansehen"
  },
  "manageCategoryPopup": {
    "title": "Schritt 1/2",
    "buttonNewCategory": "Neue Kategorie hinzufügen",
    "buttonEditCategory": "Kategorie bearbeiten",
    "changeButton": "Symbol ändern",
    "nextStep": "Nächster Schritt",
    "cancelButton": "Abbrechen",
    "inputs": {
      "categoryPlaceholder": "Kategorie eingeben",
      "categoryLabel": "Kategorie",
      "descriptionPlaceholder": "Beschreibung eingeben",
      "descriptionLabel": "Beschreibung"
    }
  },
  "manageQuestionPopup": {
    "title": "Schritt 1/2",
    "buttonNewQuestion": "Neue Frage hinzufügen",
    "buttonEditQuestion": "Frage bearbeiten",
    "nextStep": "Nächster Schritt",
    "cancelButton": "Abbrechen",
    "hintText": "Antwortmöglichkeiten sind: Stimme zu, Stimme eher zu, Neutral, Stimme eher nicht zu, Stimme nicht zu",
    "inputs": {
      "questionPlaceholder": "Frage eingeben"
    }
  },
  "translationManageQuestion": {
    "title": "Schritt 2/2",
    "checkTitle": "Übersetzung in andere Sprachen überprüfen",
    "useAITrans": "Wir verwenden KI-Übersetzungen, daher kann das Ergebnis Fehler enthalten",
    "backButton": "Zurück",
    "addQuestion": "Frage hinzufügen",
    "editQuestion": "Frage bearbeiten"
  },
  "editTranslationQuestion": {
    "title": "Übersetzung bearbeiten",
    "inputPlaceholder": "Kategoriename eingeben",
    "hintText": "Antwortmöglichkeiten sind: Stimme zu, Stimme eher zu, Neutral, Stimme eher nicht zu, Stimme nicht zu",
    "cancelButton": "Abbrechen",
    "saveButton": "Änderungen speichern"
  },
  "iconPickerCategoryPopup": {
    "buttons": {
      "backButton": "Zurück",
      "choseIconButton": "Symbol für Kategorie wählen"
    },
    "categories": {
      "performance": "Leistung",
      "communication": "Kommunikation",
      "teamCulture": "Teamkultur",
      "learning": "Lernen"
    }
  },
  "translationOverviewCategory": {
    "title": "Schritt 2/2",
    "description": "Übersetzung in andere Sprachen prüfen",
    "subtitle": "Wir verwenden KI-Übersetzung, daher kann das Ergebnis Fehler enthalten",
    "buttons": {
      "backButton": "Zurück",
      "buttonNewCategory": "Kategorie hinzufügen",
      "buttonEditCategory": "Kategorie bearbeiten"
    },
    "categoryNameText": "Kategoriebezeichnung",
    "descriptionText": "Beschreibung"
  },
  "changeQuestionPopup": {
    "title": "Frage ändern",
    "buttons": {
      "cancelButton": "Abbrechen",
      "changeButton": "Frage ändern"
    },
    "inputs": {
      "labelCategory": "Kategorie",
      "placeholderCategory": "Kategorie auswählen",
      "labelQuestion": "Frage",
      "placeholderQuestion": "Frage auswählen"
    },
    "questionHistory": {
      "lastAskedHint": "Zuletzt gefragt am {{date}}",
      "empty": "(Leer)"
    },
    "errors": {
      "updateFailed": "Der Zeitplan konnte nicht aktualisiert werden. Bitte versuche es erneut."
    }
  },
  "blocksSidebar": {
    "placeholder": "Blöcke durchsuchen",
    "filters": {
      "all": "Alle",
      "text": "Text",
      "numbers": "Zahlen",
      "graphs": "Diagramme"
    }
  },
  "dashboardSidebar": {
    "role": "Rolle",
    "profileSettings": "Profileinstellungen",
    "signOut": "Abmelden",
    "powered": "Bereitgestellt von"
  },
  "changeIndicator": {
    "noChange": "Keine Änderung"
  },
  "categoryDistributionCard": {
    "questionsCount_one": "{{count}} Frage",
    "questionsCount_other": "{{count}} Fragen"
  },
  "gaugeChart": {
    "enpsScore": "eNPS-Wert"
  },
  "pieChartSimple": {
    "previously": "{{companyScore}} % zuvor",
    "companyBaseline": "Unternehmens-Basiswert:"
  },
  "tagList": {
    "noTags": "Keine Tags"
  },
  "surveyCard": {
    "dropdown": {
      "edit": "Bearbeiten",
      "delete": "Löschen"
    },
    "useTemplate": "Vorlage verwenden",
    "preview": "Vorschau"
  },
  "translationOverviewQuestion": {
    "questionNameText": "Fragetitel"
  },
  "calendar": {
    "cancel": "Abbrechen",
    "apply": "Übernehmen"
  },
  "categoryPopup": {
    "translationEditItem": {
      "title": "Übersetzung bearbeiten",
      "cancel": "Abbrechen",
      "save": "Änderungen speichern"
    }
  },
  "shareReportPopup": {
    "title": "Bericht teilen",
    "accessReport": "Zugriff auf Bericht",
    "anyoneWithLink": "Jeder mit dem Link",
    "copyLink": "Link kopieren"
  },
  "surveyBuilderPopup": {
    "surveyInfoPopup": {
      "title": "Übersetzung bearbeiten",
      "tags": "Tags",
      "cancel": "Abbrechen",
      "save": "Änderungen speichern"
    },
    "surveyPublishPopup": {
      "title": "Umfrage veröffentlichen",
      "surveyTitle": "Umfragetitel",
      "surveyDescription": "Umfragebeschreibung",
      "tags": "Tags",
      "audienceSize": "Zielgruppengröße",
      "startDate": "Startdatum",
      "distributionMethods": "Verteilungsmethoden",
      "cancel": "Abbrechen",
      "save": "Änderungen speichern"
    },
    "surveyQuestionPopup": {
      "title": "Übersetzung bearbeiten",
      "options": "Optionen",
      "cancel": "Abbrechen",
      "save": "Änderungen speichern"
    }
  },
  "userManagementRow": {
    "seeDetails": "Details anzeigen",
    "leaderTag": "Leader",
    "roleChangeNotAllowed": "Nur Administratoren können Benutzerrollen ändern."
  },
  "errorScreen": {
    "notFound": {
      "title": "Seite nicht gefunden",
      "description": "Es sieht so aus, als wurde diese Seite verschoben oder existiert nicht mehr. Wir bringen dich wieder auf Kurs - gehe zur Übersicht oder kehre zur vorherigen Seite zurück.",
      "primaryCta": "Zur vorherigen Seite",
      "secondaryCta": "Zur Übersicht"
    },
    "generic": {
      "title": "Etwas ist schiefgelaufen",
      "description": "Wir arbeiten bereits daran, alles wiederherzustellen. Versuche es noch einmal oder gehe zurück, um dort weiterzumachen, wo alles reibungslos läuft.",
      "primaryCta": "Erneut versuchen",
      "secondaryCta": "Zurück"
    }
  },
  "deliveryPausedBanner": {
    "title": "Fragenversand ist pausiert",
    "description": {
      "manual": "Der Versand Ihrer Fragen ist derzeit angehalten. Kontaktieren Sie den Support für weitere Informationen.",
      "subscription_canceled": "Ihr Abonnement wurde gekündigt und der Fragenversand wurde gestoppt. Kontaktieren Sie den Support, um ihn wieder zu aktivieren.",
      "subscription_past_due": "Wir konnten Ihre Zahlung nicht verarbeiten. Der Fragenversand ist angehalten, bis die Zahlung aktualisiert wurde.",
      "subscription_unpaid": "Ihre Zahlung ist überfällig und der Fragenversand wurde ausgesetzt. Kontaktieren Sie den Support, um das Problem zu lösen.",
      "subscription_paused": "Ihr Abonnement ist pausiert und der Fragenversand ist angehalten. Kontaktieren Sie den Support, um fortzufahren."
    },
    "contactSupport": "Support kontaktieren"
  },
  "globalBanner": {
    "dismissFailed": "Ihre Auswahl konnte nicht gespeichert werden. Bitte versuchen Sie es erneut."
  },
  "setupIncompleteBanner": {
    "title": "Richten Sie die Einrichtung ab, um Feedback zu erhalten",
    "description": "Richten Sie Ihre Organisation ein, um Einblicke vom Team zu sammeln. Es dauert weniger als 15 Minuten.",
    "completeSetupMessage": "Einrichtung abschließen"
  }
}
